import classNames from 'classnames';
import React from 'react';
import * as Render from '../Base/Render';
import Icons from './icons';
import SelfTestQuestion from './selftestquestion';

class SelfTest extends React.Component {
  questions = [];

  state = {
    isValid: null,
    correctAnsers: null,
  };

  addCtrlToValidation(question) {
    this.questions.push(question);
  }

  validate() {
    let isValid = true;
    let numOfCorrectAnswers = this.questions.length;
    this.questions.forEach((question) => {
      if (question.validateQuestion() !== true) {
        isValid = false;
        numOfCorrectAnswers--;
      }
    });

    this.setState({
      isValid: isValid,
      correctAnsers: numOfCorrectAnswers,
    });
  }

  scrollToTop() {
    const heading = document.getElementById('result');
    if (heading !== null && typeof heading !== 'undefined') {
      heading.scrollIntoView();
      heading.focus();
      document.querySelector('.c-self-test__button[type=button]').blur();
    }
  }
  componentDidUpdate() {
    this.scrollToTop();
  }

  reset() {
    this.questions.forEach((question) => question.resetQuestion());

    this.setState({
      isValid: null,
      correctAnsers: null,
    });
    this.scrollToTop();
    let elem = document.querySelector(
      '.c-self-test .c-self-test__optionheading'
    );
    elem.setAttribute('tabindex', 0);
    elem.focus();
  }

  render() {
    const classes = classNames({
      'c-self-test': true,
      'c-self-test--is-valid': this.state.isValid,
      'c-self-test--is-error': this.state.isValid === false,
    });

    const { Translations } = this.props.Content;
    const correctTestText =
      this.state.isValid !== null
        ? Translations.correcttestagain
        : Translations.correcttest;

    return (
      <div className={classes}>
        {this.state.isValid !== null && (
          <div className="c-self-test__result">
            <h2
              className="c-self-test__result-heading"
              id="result"
              tabIndex="0"
            >
              {Translations.yougot} {this.state.correctAnsers} {Translations.of}{' '}
              {this.questions.length} {Translations.correct}
            </h2>
            {this.props.Content.AnswerSpans &&
              this.props.Content.AnswerSpans.find(
                (answer) => this.state.correctAnsers < answer.Max
              ) && (
                <div className="c-self-test__result-text-container">
                  <p className="c-self-test__result-text">
                    {
                      this.props.Content.AnswerSpans.find(
                        (answer) => this.state.correctAnsers < answer.Max
                      ).Text
                    }
                  </p>
                </div>
              )}
            {this.props.Content.FeedbackText && (
              <div
                className="c-self-test__result-text-container u-content-editable"
                dangerouslySetInnerHTML={{
                  __html: this.props.Content.FeedbackText,
                }}
              ></div>
            )}
          </div>
        )}
        {this.state.isValid !== null && (
          <div className="c-self-test__result-info" aria-hidden="true">
            <div className="c-self-test__result-info__container">
              <Icons iconType={true} />
              <span className="c-self-test__result-info__correct-answer">
                = rätt svar
              </span>
            </div>
            <div className="c-self-test__result-info__container">
              <Icons iconType={false} /> = fel eller ofullständigt svar
            </div>
          </div>
        )}

        <Render.Block
          blocks={this.props.Content.Questions}
          propertyName="Questions"
          currentPageProps={this.props}
        >
          <SelfTestQuestion
            addCtrlToValidation={(question) =>
              this.addCtrlToValidation(question)
            }
          />
        </Render.Block>
        {this.props.Content.Questions && (
          <button
            className="c-self-test__button"
            type="button"
            onClick={() => {
              this.validate();
            }}
          >
            {correctTestText}
          </button>
        )}
        {this.state.isValid !== null && (
          <button
            className="c-self-test__button c-self-test__button--secondary"
            type="reset"
            onClick={() => this.reset()}
          >
            {Translations.redotest}
          </button>
        )}
      </div>
    );
  }
}

export default SelfTest;
